import "./TimeTrackerTag.css";
import Modal from "react-modal";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { useSelector, useDispatch } from "react-redux";
import React, { useEffect, useState, useRef } from "react";
import { logout, reset } from "../../../features/auth/authSlice.js";
import {
  useCreateTag,
  useDeleteTag,
  useFetchTag,
  useUpdateTag,
} from "./tagApi.jsx";
import { reset as invoiceReset } from "../../../features/invoice/invoiceSlice.js";
import { reset as headerReset } from "../../../features/headerText/headerTextSlice.js";
import { reset as appSettingsReset } from "../../../features/appSettings/appSettingsSlice.js";

const EditIcon = () => (
  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.1913 4.65316L12.6387 1.07957C12.5877 1.02831 12.5202 1.00015 12.4481 1.00015C12.376 1.00015 12.3088 1.02831 12.2579 1.07958L10.1531 3.197L10.1506 3.20458L10.1086 3.24177L1.9793 11.4201C1.94162 11.458 1.91615 11.5057 1.90574 11.5576L1.00581 16.0375C0.987873 16.1267 1.01551 16.218 1.07939 16.2826C1.13035 16.3336 1.19782 16.3617 1.26996 16.3617C1.2879 16.3617 1.30548 16.3599 1.32199 16.3566L5.77596 15.4507C5.82835 15.4403 5.87536 15.4146 5.91269 15.3771L16.1913 5.0362C16.2422 4.98529 16.2699 4.91706 16.2699 4.8445C16.2699 4.77193 16.2419 4.70406 16.1913 4.65316ZM5.58897 14.9363L1.61338 15.7451L2.41678 11.7454L3.59027 10.5648L6.76245 13.7561L5.58897 14.9363ZM7.14285 13.373L3.97066 10.1821L10.3043 3.81036L13.4761 7.00129L7.14285 13.373ZM13.8572 6.61824L10.6854 3.42731L12.4481 1.65395L15.6203 4.84488L13.8572 6.61824Z" fill="#405BFF" stroke="#405BFF" strokeWidth="0.6"/>
  </svg>
);
const DeleteIcon = () => (
  <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16.9577 19.6445L17.4363 4.3776H19.5772V3.85206H14.0109V2.45939C14.0109 1.69736 13.4316 1.09299 12.7011 1.09299H7.966C7.23557 1.09299 6.65628 1.69736 6.65628 2.45939V3.85206H1.08997V4.3776H3.23085L3.70941 19.6445C3.73459 20.354 4.2887 20.9058 4.96875 20.9058H15.6732C16.3784 20.9058 16.9325 20.354 16.9577 19.6445ZM7.16001 2.45939C7.16001 1.9864 7.51263 1.61852 7.966 1.61852H12.7011C13.1545 1.61852 13.5071 1.9864 13.5071 2.45939V3.85206H7.16001V2.45939ZM4.21314 19.6182L3.73459 4.3776H16.9325L16.454 19.6182C16.4288 20.0386 16.1014 20.3802 15.6984 20.3802H4.96875C4.56576 20.3802 4.23833 20.0386 4.21314 19.6182Z" fill="#282828" stroke="#282828" strokeWidth="0.5"/>
    <path d="M10.0811 8.37173H10.5848V16.2285H10.0811V8.37173Z" fill="#282828" stroke="#282828" strokeWidth="0.5"/>
    <path d="M7.05884 8.37173H7.56258V16.2285H7.05884V8.37173Z" fill="#282828" stroke="#282828" strokeWidth="0.5"/>
    <path d="M13.1046 8.37173H13.6084V16.2285H13.1046V8.37173Z" fill="#282828" stroke="#282828" strokeWidth="0.5"/>
  </svg>
);
const CloseIcon = () => (
  <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.41895 12L11.9189 1.5" stroke="#000" strokeWidth="1.5"/>
    <path d="M1.41895 1.5L11.9189 12" stroke="#000" strokeWidth="1.5"/>
  </svg>
);

const TimeTrackerTag = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isSubmitLoading, setIsSubmitLoading] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [tagCreate, setTagCreate] = useState("");
  const [tagCreateError, setTagCreateError] = useState(false);
  const tagCreateRef = useRef(null);
  const [tagEdit, setTagEdit] = useState("");
  const [sortedTag, setSortedTag] = useState([]);
  const token = useSelector((state) => state.auth.token);
  const { appSettings } = useSelector((state) => state.appSettings);
  const [filter, setFilter] = useState("");
  const [selectedSortOption, setSelectedSortOption] = useState(null);
  const [checkedOption, setCheckedOption] = useState(null);
  const [sortDropdownOpen, setSortDropdownOpen] = useState(false);
  const sortDropdownRef = useRef(null);

  const { data: tag = [], isLoading, isError } = useFetchTag(token);

  const deleteTagMutation = useDeleteTag(token);
  const createTagMutation = useCreateTag(token);
  const updateTagMutation = useUpdateTag(token);


  const selectSortOption = (option) => {
    setSelectedSortOption(option);
    setCheckedOption(option);
    setSortDropdownOpen(false);
    // console.log(`Selected option: ${option}`);
  };

  const toggleSortDropdown = () => {
    setSortDropdownOpen(!sortDropdownOpen);
  };
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        document.activeElement.blur();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  // Use ref to track previous tag value and prevent infinite loops
  const previousTagRef = useRef(null);

  useEffect(() => {
    // Compare arrays to check if values have actually changed
    const arraysEqual = (a, b) => {
      if (!a || !b) return a === b;
      if (!Array.isArray(a) || !Array.isArray(b)) return a === b;
      if (a.length !== b.length) return false;
      return a.every((val, idx) => {
        // Compare objects by _id if they're objects, otherwise compare directly
        if (val && typeof val === 'object' && b[idx] && typeof b[idx] === 'object') {
          return val._id === b[idx]._id && val.tag_name === b[idx].tag_name;
        }
        return val === b[idx];
      });
    };

    const tagChanged = !arraysEqual(previousTagRef.current, tag);
    
    // Only update if tag content has actually changed
    if (tagChanged) {
      previousTagRef.current = Array.isArray(tag) ? [...tag] : tag;
      setSortedTag(Array.isArray(tag) ? [...tag] : tag);
    }
  }, [tag]);

  const sortData = (data, sortOption) => {
    if (!Array.isArray(data)) return [];
    switch (sortOption) {
      case 'By name: A - Z':
        return data.slice().sort((a, b) => (a?.tag_name || "").localeCompare(b?.tag_name || ""));
      case 'By name: Z - A':
        return data.slice().sort((a, b) => (b?.tag_name || "").localeCompare(a?.tag_name || ""));
      case 'Date: old to new':
        return data.slice().sort((a, b) => new Date(a?.created_at || 0) - new Date(b?.created_at || 0));
      case 'Date: new to old':
        return data.slice().sort((a, b) => new Date(b?.created_at || 0) - new Date(a?.created_at || 0));
      default:
        return data;
    }
  };

  const sortedData = sortData(sortedTag, selectedSortOption);

  const seen = new Set();
  const filteredData = sortedData.filter((item) => {
    if (!item?.tag_name) return false;
    if (seen.has(item.tag_name.toLowerCase())) return false;
    seen.add(item.tag_name.toLowerCase());
    return item.tag_name.toLowerCase().includes(filter.toLowerCase());
  });

  const handleOpenModal = (item) => {
    setIsModalOpen(true);
    setSelectedId(item._id);
    setTagEdit(item.tag_name);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedId("");
    setTagEdit("");
  };

  const handleDelete = () => {
    setIsDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    try {
      setIsSubmitLoading(true);
      await deleteTagMutation.mutateAsync(selectedId);
      setSortedTag((prevState) =>
        prevState.filter((tag) => tag._id !== selectedId)
      );
      toast.success("Tag removed successfully", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      global.config.activityLog(
        window.location.href,
        "Tag",
        `Tag (${selectedId}) removed successfully`
      );
      handleCloseModal();
    } catch (error) {
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error("Something went wrong", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(error.response.data.message); // print server error message
    } finally {
      setIsSubmitLoading(false);
    }
    setIsDeleteModalOpen(false);
  };

  const handleCancelDelete = () => {
    setIsDeleteModalOpen(false);
  };

  const handleCreateSubmit = async (event) => {
    event.preventDefault();
    if (tagCreate.trim() === "") {
      setTagCreateError(true);
      tagCreateRef.current.focus();
      return;
    }
    setTagCreateError(false);

    const requestData = {
      tag_name: tagCreate,
    };
    try {
      setIsSubmitLoading(true);
      const data = await createTagMutation.mutateAsync(requestData);
      if (data.status === "error") {
        toast.error("Something went wrong", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "Tag",
          `Something went wrong while adding Tag`
        );
      } else if (data.status === "exists") {
        toast.error("Tag with the same name already exists", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "Tag",
          `Tag ${tagCreate} already exist`
        );
      } else {
        toast.success("Tag added successfully", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "Tag",
          `Tag ${tagCreate} added successfully`
        );
        setTagCreate("");
      }
    } catch (error) {
      console.log(error);
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      toast.error("Something went wrong");
      global.config.activityLog(
        window.location.href,
        "Tag",
        `Something went wrong`
      );
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleUpdateSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsSubmitLoading(true);
      const response = await updateTagMutation.mutateAsync({
        selectedId,
        tag_name: tagEdit,
      });
      const data = response.data;
      if (data.status === "error") {
        toast.error("Something went wrong", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else if (data.status === "exists") {
        toast.error(`Tag with the "${tagEdit}" name already exists`, {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      } else {
        setSortedTag((prevState) => {
          const updatedTag = prevState.map((item) => {
            if (item._id === selectedId) {
              return { ...item, tag_name: tagEdit };
            }
            return item;
          });
          return updatedTag;
        });
        toast.success("Tag updated successfully", {
          position: "bottom-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
        global.config.activityLog(
          window.location.href,
          "Tag",
          `Tag "${tagEdit}" updated successfully`
        );
        handleCloseModal();
      }
    } catch (error) {
      console.log(error.response.data.message); // print server error message
      global.config.slackMessage(error.toString());
      if (error.response?.data?.status === "deleted") {
        localStorage.removeItem("user");
        dispatch(logout());
        dispatch(reset());
        dispatch(invoiceReset());
        dispatch(headerReset());
        dispatch(appSettingsReset());
        toast.error("This user is deleted!", {
          position: "bottom-right",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        navigate("/");
        return;
      }
      alert("Something went wrong");
    } finally {
      setIsSubmitLoading(false);
    }
  };

  const handleClickOutsideDropdown = (event) => {
    const isClickInsideSortDropdown = sortDropdownRef.current && sortDropdownRef.current.contains(event.target);

    if (!isClickInsideSortDropdown) {
      setSortDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleClickOutsideDropdown);
    return () => {
      document.removeEventListener('click', handleClickOutsideDropdown);
    };
  }, []);

  return (
    <div>
      <div className="div-outter-for-department">
        <div className="add-department-section top-filter-client-inner">
          <div className="top-filter-client-inner-left">
            <input
              type="text"
              placeholder={global.config.locate(
                appSettings && appSettings.language,
                "Add new tag"
              )}
              value={tagCreate}
              onChange={(e) => { setTagCreate(e.target.value); if (tagCreateError) setTagCreateError(false); }}
              onBlur={() => { if (tagCreateError) setTagCreateError(false); }}
              ref={tagCreateRef}
              style={tagCreateError ? { border: "1px solid #ff6b6b", backgroundColor: "#fff5f5" } : undefined}
            />
            <button
              className="add-btn-in-department-b1"
              onClick={isSubmitLoading ? undefined : handleCreateSubmit}
              disabled={isSubmitLoading}
              style={{
                pointerEvents: isSubmitLoading ? "none" : "auto",
                cursor: isSubmitLoading ? "default" : "pointer",
                opacity: isSubmitLoading ? 0.7 : 1,
              }}
            >
              {isSubmitLoading ? (
                <div
                  style={{
                    width: "21px",
                    height: "21px",
                    backgroundColor: "rgba(255, 255, 255, 0.5)",
                    borderRadius: "4px",
                    animation: "pulse 1.5s ease-in-out infinite",
                  }}
                />
              ) : (
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M7.75 0V15.5" stroke="white" strokeWidth="1.5"/><path d="M15.5 7.75L0 7.75" stroke="white" strokeWidth="1.5"/></svg>
              )}
            </button>
          </div>
          <div className="top-filter-client-sort">

            <div className="custom-dropdown1">
              <div
                ref={sortDropdownRef}
                className={`custom-dropdown-user-new-outer custom-dropdown-select ${sortDropdownOpen ? 'open' : ''}`}
              >
                <div className="selected-option custom-dropdown-user-new" onClick={toggleSortDropdown}>
                <div className="center-sort">
                  {selectedSortOption ? selectedSortOption : 'Sort By'}
                  </div>
                </div>
                {sortDropdownOpen && (
                  <div className="custom-dropdown-new">
                    <ul className="type-list">
                      <li
                        className={checkedOption === 'By name: A - Z' ? 'selected' : ''}
                        onClick={() => selectSortOption('By name: A - Z')}
                      >
                        <span className={`checkbox ${checkedOption === 'By name: A - Z' ? 'checked' : ''}`}></span>
                        By name: A - Z
                      </li>
                      <li
                        className={checkedOption === 'By name: Z - A' ? 'selected' : ''}
                        onClick={() => selectSortOption('By name: Z - A')}
                      >
                        <span className={`checkbox ${checkedOption === 'By name: Z - A' ? 'checked' : ''}`}></span>
                        By name: Z - A
                      </li>
                      <li
                        className={checkedOption === 'Date: old to new' ? 'selected' : ''}
                        onClick={() => selectSortOption('Date: old to new')}
                      >
                        <span className={`checkbox ${checkedOption === 'Date: old to new' ? 'checked' : ''}`}></span>
                        Date: old to new
                      </li>
                      <li
                        className={checkedOption === 'Date: new to old' ? 'selected' : ''}
                        onClick={() => selectSortOption('Date: new to old')}
                      >
                        <span className={`checkbox ${checkedOption === 'Date: new to old' ? 'checked' : ''}`}></span>
                        Date: new to old
                      </li>
                      {/* Add more sorting options as needed */}
                    </ul>
                  </div>
                )}
              </div>
            </div>
            <div className="top-filter-client-sort-search">
              <div className="top-filter-client-search">
                <div className="search-sec">
                  <div className="search-container">
                    <input type="text" className="search-input" placeholder="Search by tag name" onChange={(e) => setFilter(e.target.value)} value={filter} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="department-section-listing">
          {isLoading === true ? (
            <>
              {Array.from({ length: 24 }).map((_, index) => (
                <div className="grid-item" key={`skeleton-tag-${index}`} style={{ pointerEvents: "none", cursor: "default" }}>
                  <div
                    className="input-tag"
                    style={{
                      width: "100%",
                      height: "40px",
                      backgroundColor: "#e5e7eb",
                      borderRadius: "10px",
                      animation: "pulse 1.5s ease-in-out infinite",
                      border: "none",
                      paddingLeft: "15px",
                    }}
                  />
                </div>
              ))}
            </>
          ) : (
            <>
              {filteredData.map((item, index) => (
                  <div className="grid-item" key={item._id}>
                    <input
                      type="text"
                      className="input-tag"
                      value={item.tag_name}
                      readOnly
                    />
                    <button
                      className="edit-button"
                      onClick={() => handleOpenModal(item)}
                    >
                      <EditIcon />
                      {global.config.locate(
                        appSettings && appSettings.language,
                        "Edit"
                      )}
                    </button>
                  </div>
                ))
              }
            </>
          )}
        </div>
        {!isLoading && filteredData.length === 0 && (
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", padding: "48px 24px", gap: "10px" }}>
            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="6" y="10" width="32" height="26" rx="3" stroke="#D0D5DD" strokeWidth="2"/>
              <path d="M6 16h32" stroke="#D0D5DD" strokeWidth="2"/>
              <path d="M14 7v6M30 7v6" stroke="#D0D5DD" strokeWidth="2" strokeLinecap="round"/>
              <path d="M13 24h6M13 29h12" stroke="#BDBDBD" strokeWidth="2" strokeLinecap="round"/>
            </svg>
            <p style={{ margin: 0, fontSize: "15px", fontWeight: "500", color: "#282828" }}>No tags found</p>
            <p style={{ margin: 0, fontSize: "13px", color: "#96A8BA" }}>Add a new tag to get started.</p>
          </div>
        )}
      </div>
      <div className="modal-invite-main-outter">
        <Modal
          className="client-modal leave"
          isOpen={isModalOpen}
          onRequestClose={handleCloseModal}
          contentLabel="New TAG"
          style={{
            content: {
              height: "41%",
              width: "30%",
              position: "fixed",
              top: "50%",
              left: "50%",
              parent: document.querySelector(".admin-outer.time.tracker"),
            },
          }}
        >
          <div className="modal">
            <div className="modal-close-invite outter-modal-main">
              <a className="" onClick={handleCloseModal}>
                <CloseIcon />{" "}
              </a>
            </div>
            <div className="modal-client-head">
              <h2 className="">
                {global.config.locate(
                  appSettings && appSettings.language,
                  "Edit Tag"
                )}
              </h2>
            </div>
            <div className="form-field-client-outer">
              <form onSubmit={handleUpdateSubmit}>
                <div className="form-field-client">
                  <label htmlFor="clientName" className="form-label">
                    {global.config.locate(
                      appSettings && appSettings.language,
                      "Tag Name"
                    )}
                  </label>
                  <input
                    type="text"
                    id="clientName"
                    name="clientName"
                    className="form-input"
                    value={tagEdit}
                    onChange={(e) => setTagEdit(e.target.value)}
                    required
                  />
                </div>
                {isSubmitLoading ? (
                  <div className="form-field-client-btns" style={{ pointerEvents: "none", cursor: "default", opacity: 0.7 }}>
                    <div
                      className="delete-client"
                      style={{
                        width: "100%",
                        height: "44px",
                        backgroundColor: "#F5F6F8",
                        border: "0.2px solid #282828",
                        borderRadius: "6px",
                        animation: "pulse 1.5s ease-in-out infinite",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gridGap: "14.33px",
                      }}
                    >
                      <div
                        style={{
                          width: "20px",
                          height: "22px",
                          backgroundColor: "rgba(40, 40, 40, 0.3)",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                      <div
                        style={{
                          width: "60px",
                          height: "17px",
                          backgroundColor: "rgba(40, 40, 40, 0.3)",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    </div>
                    <div
                      className="save-changes"
                      style={{
                        width: "100%",
                        height: "44px",
                        backgroundColor: "#6479F8",
                        borderRadius: "6px",
                        animation: "pulse 1.5s ease-in-out infinite",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <div
                        style={{
                          width: "100px",
                          height: "17px",
                          backgroundColor: "rgba(255, 255, 255, 0.7)",
                          borderRadius: "4px",
                          animation: "pulse 1.5s ease-in-out infinite",
                        }}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="form-field-client-btns">
                    <button
                      type="button"
                      className="delete-client"
                      onClick={handleDelete}
                      disabled={isSubmitLoading}
                    >
                      <DeleteIcon />{" "}
                      {global.config.locate(
                        appSettings && appSettings.language,
                        "Delete"
                      )}
                    </button>
                    <Modal
                      className="delete-modal"
                      isOpen={isDeleteModalOpen}
                      onRequestClose={handleCancelDelete}
                      contentLabel="Confirm Delete"
                      style={{
                        content: {
                          height: "41%",
                          width: "30%",
                          position: "fixed",
                          top: "36%",
                          left: "50%",
                          parent: document.querySelector(
                            ".admin-outer.time.tracker"
                          ),
                        },
                      }}
                    >
                      <div className="delete-modal-content">
                        <h2>
                          {global.config.locate(
                            appSettings && appSettings.language,
                            "Confirm_Delete"
                          )}
                        </h2>
                        <p>
                          {global.config.locate(
                            appSettings && appSettings.language,
                            "Are you sure you want to delete this Tag?"
                          )}
                        </p>
                        {isSubmitLoading ? (
                          <div className="delete-modal-buttons" style={{ pointerEvents: "none", cursor: "default", opacity: 0.7 }}>
                            <div
                              className="delete"
                              style={{
                                width: "100px",
                                height: "40px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                style={{
                                  width: "60px",
                                  height: "18px",
                                  backgroundColor: "#cbd5e1",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                width: "100px",
                                height: "40px",
                                backgroundColor: "#e5e7eb",
                                borderRadius: "4px",
                                animation: "pulse 1.5s ease-in-out infinite",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                              }}
                            >
                              <div
                                style={{
                                  width: "60px",
                                  height: "18px",
                                  backgroundColor: "#cbd5e1",
                                  borderRadius: "4px",
                                  animation: "pulse 1.5s ease-in-out infinite",
                                }}
                              />
                            </div>
                          </div>
                        ) : (
                          <div className="delete-modal-buttons">
                            <button
                              className="delete"
                              onClick={handleConfirmDelete}
                              disabled={isSubmitLoading}
                            >
                              {global.config.locate(
                                appSettings && appSettings.language,
                                "Delete"
                              )}
                            </button>
                            <button onClick={handleCancelDelete}>
                              {global.config.locate(
                                appSettings && appSettings.language,
                                "Cancel"
                              )}
                            </button>
                          </div>
                        )}
                      </div>
                    </Modal>
                    <button
                      type="submit"
                      className="save-changes"
                      disabled={isSubmitLoading}
                    >
                      {global.config.locate(
                        appSettings && appSettings.language,
                        "Save_changes"
                      )}
                    </button>
                  </div>
                )}
              </form>
            </div>
          </div>
        </Modal>
      </div>
      {/* Pulse animation style */}
      <style>{`
        @keyframes pulse {
          0%, 100% {
            opacity: 1;
          }
          50% {
            opacity: 0.5;
          }
        }
      `}</style>
    </div>
  );
};

export default TimeTrackerTag;
